import React from "react";

//Common
import { DataGrid, Button } from "../../common/VFX-UI";
import PageHeader from "../../common/PageHeader/PageHeader";
import MoreActionsMenu from "../../common/MoreActionsMenu/MoreActionsMenu";
import SearchContainer from "../../common/Forms/SearchContainer/SearchContainer";
import { SearchFieldsDefaultValue } from "../../../utility/constants/constants";

//App
import useCampaignStyles from ".././styles";
import { SearchProps } from "../../../types";
import { SearchDefaultValue } from "../../../store/types";
import { DonorCampaignDto } from "../../../app/model/api/types/dto/donorCampaignDto";
import useDonorCampaign from "./hooks/useDonorCampaign";
import { DonorProps } from "../../../types/donorCampaign";
import { getFormattedDate } from "../../../utility/lib/date";
import { formatCurrency } from "../../../utility/lib/format";

const Donors: React.FC<DonorProps> = (props) => {
  const campaignStyles = useCampaignStyles();

  const {
    data,
    activateMutation,
    deleteMutation,
    campaignName,
    handleOnClose,
  } = props;

  const {
    formContext,
    rowEvents,
    actionColumnAnchorEl,
    toggleViewHandler,
    setActionColumnAnchorEl,
  } = useDonorCampaign({
    deleteMutation: deleteMutation,
    activateMutation: activateMutation,
  });

  const openMenu = Boolean(actionColumnAnchorEl);

  const columns = [
    {
      dataField: "id",
      text: "id",
      hidden: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true
      },
      {
          dataField: "hasResponded",
          text: "Responded",
          sort: true,
          formatter: (cell: any, row: any) => {
              return <>{row?.hasResponded ? 'YES' : 'NO'}</>
          },
      },
      {
          dataField: "pledgeDate",
          text: "Pledge Date",
          sort: false,
          formatter: (cell: Date, row: any) => {
              return getFormattedDate(cell?.toString());
          },
      },
      {
          dataField: "paymentOptionName",
          text: "Payment Type",
          sort: false,
      },
      {
      dataField: "contributionAmount",
      text: "Amount",
      sort: false,
      formatter: (cell: any, row: any) => {
          return <>{ formatCurrency(row?.contributionAmount)}</>
      },
    },
  ];

  const searchProps: SearchProps<DonorCampaignDto> = {
    searchValue: formContext?.searchValue ?? SearchDefaultValue,
    searchFields: { ...SearchFieldsDefaultValue, name: true },
    setSearchValue: formContext?.setSearchValue,
    refetchGrid: formContext?.refetchGrid,
  };
  return (
    <>
      <>
        <PageHeader>{campaignName + " - Campaign Donors"}</PageHeader>

        <div style={campaignStyles.searchCampaignContainer}>
          <SearchContainer
            searchProps={searchProps}
            activeToggle={formContext?.activeToggle ?? true}
          />
          <Button
            onClick={handleOnClose}
            style={campaignStyles.completeButton}
            className="btn mb-3"
          >
            {"Back"}
          </Button>
        </div>
      </>

      <DataGrid
        columns={columns}
        data={data}
        keyField="id"
        rowEvents={rowEvents}
        totalSize={formContext?.paging?.totalSize}
        remote={true}
        page={formContext?.paging?.currentPage}
        pageSize={formContext?.pageSize}
        handlePageChange={async (newPage, pageSize, sortField, sortOrder) => {
          if (formContext?.setCurrentPage && newPage) {
            await formContext?.setCurrentPage(newPage);
          }
          if (formContext?.setCurrentPageSize && pageSize) {
            await formContext?.setCurrentPageSize(pageSize);
          }
          if (formContext?.setSortBy && sortField && sortOrder) {
            await formContext?.setSortBy({
              field: sortField,
              direction: sortOrder === "asc" ? 1 : -1,
            });
          }
          formContext?.refetchGrid();
        }}
      />

      {actionColumnAnchorEl && (
        <MoreActionsMenu
          isOpen={openMenu}
          target={actionColumnAnchorEl}
          toggle={() => {
            setActionColumnAnchorEl(null);
          }}
          onViewClick={() => {
            toggleViewHandler();
            setActionColumnAnchorEl(null);
          }}
        ></MoreActionsMenu>
      )}
    </>
  );
};

export default Donors;
